import { ReactNode } from "react";

import {
  SectionButtons,
  SectionForm,
  PageWrapper,
  Page,
  Section,
} from "./section-components";
import { AutoFillStatus, TeamItem } from "../types";

export type IntakeAutoFillProps = {
  team: TeamItem;
  sidebar: boolean;
  children?: ReactNode;
  onSubmit: () => void;
  onSkip: () => void;
  submitError?: string;
  isUploading?: boolean;
  someUploaded?: boolean;
  disabled?: boolean;
  autoFillStatus?: AutoFillStatus;
  setSidebar: (sidebar: boolean) => void;
  isTeamHidden?: boolean;
};

export const IntakeAutoFill = ({
  team,
  sidebar,
  children,
  onSubmit,
  onSkip,
  submitError,
  isUploading,
  someUploaded,
  disabled,
  autoFillStatus,
  setSidebar,
  isTeamHidden,
}: IntakeAutoFillProps) => {
  const onNext = someUploaded && !disabled ? onSubmit : onSkip;

  return (
    <PageWrapper sidebar={sidebar}>
      <Page>
        <Section>
          <SectionForm isForm={false}>
            <SectionButtons
              isForm={false}
              team={team}
              hasError={submitError}
              onNext={onNext}
              setSidebar={setSidebar}
              disabled={{
                next:
                  autoFillStatus === "filling" ||
                  autoFillStatus === "completed" ||
                  isUploading,
              }}
              showSectionsButton
              isTeamHidden={isTeamHidden}
            >
              {children}
            </SectionButtons>
          </SectionForm>
        </Section>
      </Page>
    </PageWrapper>
  );
};
